import { useCurrentSessionUserField } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export const useIsGroupsEnabled: UseUIFeatureCheck = () => !useCurrentSessionUserField('isGuest');
